import { FC, Dispatch, SetStateAction } from 'react'
import { Menu, ListItemIcon, ListItemText, MenuItem, Divider } from '@mui/material'

interface IMenuItems {
  id: string
  anchorEl: null | Element
  setIsMenuOpen: Dispatch<SetStateAction<null | Element>>
  items: {
    text?: string | JSX.Element
    onClick?: any
    icon?: any
    hidden?: boolean
    disabled?: boolean
    divider?: boolean
    preventCloseOnClick?: boolean
    sx?: { [key: string]: string }
  }[]
  onClose?: any
  sx?: { [key: string]: string }
  position?: {
    vertical: 'top' | 'bottom'
    horizontal: 'left' | 'right'
  },
}

const PopupMenu: FC<IMenuItems> = ({
  id,
  anchorEl,
  setIsMenuOpen,
  items,
  sx = {},
  onClose,
  position = {
    vertical: 'bottom',
    horizontal: 'right',
  },
}) => {
  return (
    <Menu
      id={id}
      open={Boolean(anchorEl)}
      onClose={() => {onClose ? onClose() : (null as Function); setIsMenuOpen(null)}}
      anchorEl={anchorEl}
      anchorOrigin={position}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{ sx }}
    >
      {items.map((item: any, index: number) => (
        <span key={index}>
          <MenuItem
            onClick={(e: React.MouseEvent<HTMLElement>) => {
              item.onClick ? item.onClick(e, item.text) : (null as Function)
              item.preventCloseOnClick ?  (null as Function) : setIsMenuOpen(null)
            }}
            disabled={item.disabled}
            sx={{ display: item.hidden ? 'none' : 'flex', ...(item.sx ? item.sx : {}) }}
          >
            {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
            {item.text && <ListItemText>{item.text}</ListItemText>}
          </MenuItem>
          {item.divider && <Divider />}
        </span>
      ))}
    </Menu>
  )
}
export default PopupMenu
